/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// utils
import { asyncGetMigrationStatus, asyncUpdateMigrationStatus, asyncGetUpdatedCodes } from 'utils/api/advanced'
import { setCommentingUnitUUID } from './configurationStatus'

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const GET_MIGRATION_STATUS_FETCHING = 'GET_MIGRATION_STATUS_FETCHING';
export const GET_MIGRATION_STATUS_SUCCESS = 'GET_MIGRATION_STATUS_SUCCESS';
export const GET_MIGRATION_STATUS_ERROR = 'GET_MIGRATION_STATUS_ERROR';
export const GET_UPDATED_CODES_SUCCESS = 'GET_UPDATED_CODES_SUCCESS';

export const getMigrationStatus = commentingUnitUUID => dispatch => {
  dispatch(getMigrationStatusFetching(true));
  return asyncGetMigrationStatus(commentingUnitUUID)
    .then(response => dispatch(getMigrationStatusSuccess(response.data)))
    .catch(() => dispatch(getMigrationStatusError()))
    .finally(() => dispatch(getMigrationStatusFetching(false)))
};

export const updateMigrationStatus = (commentingUnitUUID, status) => dispatch => {
  dispatch(getMigrationStatusFetching(true))
  let newCommentingUnitUUID = null
  return asyncUpdateMigrationStatus(commentingUnitUUID, status)
    .then(response => {
      newCommentingUnitUUID = response.data
      dispatch(setCommentingUnitUUID(newCommentingUnitUUID))
    })
    .finally(() => {
      // After migration start refetch migration status
      newCommentingUnitUUID && dispatch(getMigrationStatus(newCommentingUnitUUID))
    })
}

export const getMigrationStatusFetching = isFetching => dispatch => dispatch({
  type: GET_MIGRATION_STATUS_FETCHING,
  data: isFetching
})

export const getMigrationStatusSuccess = data => dispatch => dispatch({
  type: GET_MIGRATION_STATUS_SUCCESS,
  data
})

export const getMigrationStatusError = () => dispatch => dispatch({
  type: GET_MIGRATION_STATUS_ERROR
})


export const getUpdatedCodes = (siteUUID) => dispatch => {
  return asyncGetUpdatedCodes(siteUUID)
    .then(response => {
      dispatch(getUpdatedCodesSuccess(response.data))
    })
}

export const getUpdatedCodesSuccess = data => dispatch => dispatch({
  type: GET_UPDATED_CODES_SUCCESS,
  data
})